var SpriteSymbol = require("../../node_modules/svg-baker-runtime/browser-symbol.js");
var sprite = require("../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js");
var symbol = new SpriteSymbol({
  "id": "check_out",
  "use": "check_out-usage",
  "viewBox": "0 0 20 24",
  "content": "<symbol viewBox=\"0 0 20 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"check_out\">\n<rect y=\"9.89282\" width=\"20\" height=\"13.8571\" rx=\"4\" fill=\"#56B16F\" />\n<path d=\"M6 5.99923C6 3.79009 7.79086 2 10 2V2C12.2091 2 14 3.79089 14 6.00003C14 7.71132 14 6.38583 14 12H6C6 10.1948 6 7.92185 6 5.99923Z\" stroke=\"#56B16F\" stroke-width=\"4\" />\n</symbol>"
});
var result = sprite.add(symbol);
module.exports = symbol